import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import MethodePayementChargeTotal from "./payement/MethodePayementChargeTotal";
import MethodePayementChargeAvance from "./payement/MethodePayementChargeAvance";
import ChargeService from "../../../services/ChargesPayement/ChargeService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import ListTotalPayementBill from "../../../components/finance/payement/ListTotalPayementBill";
import UtilsFormule from "../../../utils/UtilsFormule";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";

import ChargesRateTable from "./ChargesRateTable";
import ChargeReceiptPdf from "./ChargeReceiptPdf";
import { pdf } from "@react-pdf/renderer";
import SocieteAndUserService from "../../../services/societeAndUser";
const AddPayementCharge = ({ startLoading, stopLoading }) => {
  const [buttonClicked, setButtonClicked] = useState("");
  const [ChoosePayement, setChoosePayement] = useState("");
  const [chargeEtat, setChargeEtat] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [restToPay, setRestToPay] = useState(0);
  const [payed, setPayed] = useState(0);
  const [payementInformations, setPayementInformations] = useState({});
  const [totalPayementInformation, setTotalPayementInformation] = useState({});
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState([]);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const [societe, setSociete] = useState(null);
  const [generatingReceipt, setGeneratingReceipt] = useState(false);

  // company shown in the header of the reçu de paiement
  useEffect(() => {
    SocieteAndUserService.getSocieteByIdUser()
      .then((response) => {
        if (response.data.Societe) {
          setSociete(response.data.Societe);
        }
      })
      .catch((e) => {
        console.log("error in getSocieteByIdUser", e);
      });
  }, []);

  useEffect(() => {
    startLoading();
    ChargeService.getChargeEtatByIdAndSociete(
      getCurrentUserId(),
      localStorage.getItem("chargeId")
    )
      .then((response) => {
        setChargeEtat(response?.data?.success);
        localStorage.setItem("restToPay",response?.data?.success.price)
        setRestToPay(response?.data?.success.price);
        setPayed(response?.data?.success.payed);
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });

    startLoading();
    ChargeService.getChargePayementInformation(
      getCurrentUserId(),
      localStorage.getItem("chargeId")
    )
      .then((response) => {
        if (response.data["Payement"]) {
          setPayementInformations(response.data["Payement"]);
          if (response.data["Payement"]?.id != null) {
            localStorage.setItem("restToPay",response.data["Payement"]?.restToPay)

            setRestToPay(response.data["Payement"]?.restToPay);
          }
        } else if (response.data["payementInformationCharge"]) {
          setTotalPayementInformation(
            response.data["payementInformationCharge"]
          );
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setChoosePayement(payement);

    console.log("methode Payement", ChoosePayement);
  };
  const payementChooseUI = () => {
    if (ChoosePayement === "TOTAL") {
      return (
        <section class="content">
          <div class="row">
            <div class="col-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h3 className="card-title">2-Deuxième étape:</h3>
                </div>
                <MethodePayementChargeTotal />
              </div>
            </div>
          </div>
        </section>
      );
    } else if (ChoosePayement === "AVANCE") {
      return (
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">2-Deuxième étape: </h3>
              </div>
              <MethodePayementChargeAvance />
            </div>
          </div>
        </div>
      );
    }
  };
  const DynamiquePayement = () => {
    if (buttonClicked === "clicked") {
      return (
        <section className="content-header">
          <div className="card card-dark ">
            <div className="card-header">
              <h3 className="card-title">1-Première étape: </h3>
              <br />
            </div>

            <div className="card-body">
              <h5 className="card-title">
                Choisir de payer la totalité du montant ou une avance
              </h5>
              <div class="row">
                <div class="col-2"></div>
                <div class="col-10">
                  <select
                    class="form-control"
                    onChange={(e) => handleChangePayement(e)}
                  >
                    <option key={0} value={0}>
                      Payer
                    </option>
                    <option key={1} value={"TOTAL"}>
                      La totalité du montant
                    </option>
                    <option key={2} value={"AVANCE"}>
                      Une avance
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {payementChooseUI()}
        </section>
      );
    }
  };
  const buttonPayement = () => {
    if(chargeEtat?.payed===0){
      return (
        <button
          type="submit"
          onClick={(e) => {
            setButtonClicked("clicked");
          }}
          className="btn btn-dark float-right"
        >
          Payer
        </button>
      );
    }else if(chargeEtat?.payed===1){
      return (
        <button
        disabled
          type="submit"
          // onClick={(e) => {
          //   setButtonClicked("clicked");
          // }}
          className="btn btn-dark float-right"
        >
          Payée
        </button>
      );
    }
    
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const uploadQuitance = () => {
    startLoading();

    if (file.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", file);
      uploadAndDownloadService
        .uploadFile("/retail/uploadFile/uploadFile/Charge", uploadData)
        .then((response) => {
          if (response.data["success"]) {
            let uploadModel = {
              idUser: getCurrentUserId(),
              urlFileUploaded: response.data.success,
              idCharge: localStorage.getItem("chargeId"),
            };
            ChargeService.uploadQuitance(uploadModel)
              .then((response) => {
                console.log(response);
                if (response.data["error"]) {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :  " + response.data["error"]);
                } else {
                  setTimeout(() => {
                    window.location.reload(true);
                  }, 2000);
                }
              })
              .catch((error) => {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur :  " + error);
              });
          } else {
          }
        })
        .catch(() => {})
        .finally(() => {
          stopLoading();
        });
    } else {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : pas de fichier");
    }
  };

  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(e.target.files[0].name);

      setFile(e.target.files[0]);
    }
  };
  // payments of the charge: list of partial payments (avance) or one total payment
  const chargePayments = () => {
    if (payementInformations?.payementInformationCharge?.length > 0) {
      return payementInformations.payementInformationCharge;
    }
    if (totalPayementInformation?.payementInformation) {
      return [totalPayementInformation.payementInformation];
    }
    return [];
  };

  const onGenerateReceiptHandler = async () => {
    const payments = chargePayments();
    if (payments.length === 0) {
      setOpenInfoAlert(true);
      setInfoAlertText("Aucun paiement pour cette charge");
      return;
    }
    setGeneratingReceipt(true);
    try {
      const totalPaid = Math.max(
        0,
        Number(chargeEtat?.price || 0) - Number(restToPay || 0)
      );
      const blob = await pdf(
        <ChargeReceiptPdf
          societe={societe}
          charge={chargeEtat}
          payments={payments}
          totalPaid={totalPaid}
          restToPay={restToPay}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `recu_paiement_${chargeEtat?.ref || chargeEtat?.id}.pdf`;
      link.click();
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : génération du reçu impossible");
    } finally {
      setGeneratingReceipt(false);
    }
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {chargeEtat && (
        <section className="content-header">
          <div className="container-fluid">
            <div className="card card-dark">
              <div className="card-header">
                Charge: {chargeEtat?.ref} - {chargeEtat?.title}
                <small className="float-right">
                  Date: {UtilsFormule.formatDate(chargeEtat?.creationDate)}
                </small>
              </div>{" "}
              <div className="card-body">
                <div className="row">{chargeEtat?.description}</div>
                <div className="row">
                  <div class="col-6"></div>
                  <div class="col-6">
                    <ChargesRateTable extracts={chargeEtat?.chargeValues} />
                  </div>
                </div>
                <div className="row">
                  <div class="col-7"></div>
                  <div class="col-5">
                    <div className="table-responsive ">
                      <table className="table">
                        <tbody>
                          <tr>
                            <th style={{ width: "50%" }}>Total :</th>
                            <td>{chargeEtat?.price} DNT</td>
                          </tr>
                          <tr>
                            <th style={{ width: "50%" }}>Reste à payer :</th>
                            <td>{restToPay} DNT</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {chargeEtat?.urlFileUploaded === "none" && (
                  <div className="row">
                    <div class="col-md-12">
                      <div className="row">
                        <div className="col-sm-12">
                          <div class="form-group">
                            <label for="exampleInputFile">
                              Ajouter Quitance{" "}
                            </label>
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  accept="application/pdf, .jpg, .jpeg, .png"
                                  type="file"
                                  className="custom-file-input"
                                  id="exampleInputFile"
                                  onChange={onUploadFileHandler}
                                />
                                <label
                                  class="custom-file-label"
                                  for="exampleInputFile"
                                >
                                  {fileName}{" "}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <button
                        class="btn bg-gray btn-sm float-right"
                        onClick={() => uploadQuitance()}
                      >
                        Upload Quitance
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="card-footer">   <div className="row">
                    <div class="col-md-2">
                {chargeEtat?.urlFileUploaded !== "none" && (
                  <button
                    class="btn bg-gray btn-sm "
                    onClick={() =>
                      onShowFileInOtherWizndowHandler(
                        chargeEtat?.urlFileUploaded
                      )
                    }
                  >
                    <i class="fas fa-eye"></i> Quitance
                  </button>
                )}
                </div>
                <div class="col-md-1">
                <button
                  class="btn bg-gray btn-sm "
                  title="Générer le reçu de paiement (PDF)"
                  disabled={generatingReceipt || chargePayments().length === 0}
                  onClick={onGenerateReceiptHandler}
                >
                  <i class="fas fa-receipt"></i>{" "}
                  {generatingReceipt ? "..." : "Reçu"}
                </button>
                </div>
                <div class="col-md-9">
                {buttonPayement()}
                </div>
              </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <br />
      {DynamiquePayement()}
      <section className="content-header">
          <div className="container-fluid">
      {payementInformations?.id != null ? (
        <ListTotalPayementBill
          payementInformations={payementInformations?.payementInformationCharge}
          hideReceipt
        />
      ) : null}
      </div></section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddPayementCharge);
